import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
export const IconLabel = ({ color, isLeft, isRight, label, leftIcon, rightIcon, alignItems = 'center', className = '', gap = '8', ...props })=>{
    return /*#__PURE__*/ _jsxs(Flex, {
        alignItems: alignItems,
        gap: gap,
        children: [
            isLeft && leftIcon,
            /*#__PURE__*/ _jsx(Box, {
                children: /*#__PURE__*/ _jsx(Text, {
                    children: label
                })
            }),
            isRight && rightIcon
        ]
    });
};
IconLabel.displayName = 'IconLabel';
export default IconLabel;
